module.exports = __webpack_public_path__ + "media/images/project/delete-2b37ebee522fa07f7b1d8084f858b2d9.svg";